import { Button, Modal, Spacer, SvgSparkle, Text } from '@loomhq/lens';
import React, { useCallback, useEffect } from 'react';

import {
  CONTENT_LIMIT_MODAL_CLICKED,
  CONTENT_LIMIT_MODAL_DISMISSED,
  CONTENT_LIMIT_MODAL_SHOWN,
} from 'constants/events';
import { PLANS_AND_BILLING } from 'constants/routes';
import { CONTENT_LIMIT_MODAL } from 'constants/scopes';
import { track } from 'utilities/analytics';

import contentLimitIcon from 'img/logos/content-limit.svg';
import { useWorkspaceCounts } from 'hooks/useCounts';
import { useWorkspaceLimit } from 'hooks/useWorkspaceLimit';
import { useGetSelectedWorkspace } from 'hooks/workspace';

import Scopes from 'components/scopes';

const ContentLimitPaywallModal = ({ contentType = 'recording' }) => {
  const [showModal, setShowModal] = React.useState(false);
  const selectedWorkspace = useGetSelectedWorkspace();
  const limits = useWorkspaceLimit();
  const counts = useWorkspaceCounts();

  const getAnalyticsData = useCallback(
    counts => ({
      userId: window.loomSSRUser.id,
      userEmail: window.loomSSRUser.email,
      workspaceId: selectedWorkspace.id,
      totalVideos: counts?.videos?.total_workspace_videos || 0,
      totalScreenshots: counts?.screenshots?.total_workspace_screenshots || 0,
    }),
    [selectedWorkspace.id]
  );

  const onClose = () => {
    track(CONTENT_LIMIT_MODAL_DISMISSED, getAnalyticsData(counts));
    setShowModal(!showModal);
  };

  useEffect(() => {
    const totalAssets =
      counts?.videos?.total_workspace_videos +
      counts?.screenshots?.total_workspace_screenshots;

    const shouldShowModal = totalAssets >= limits?.TOTAL_ASSETS;

    if (shouldShowModal) {
      track(CONTENT_LIMIT_MODAL_SHOWN, getAnalyticsData(counts));
    }

    setShowModal(shouldShowModal);
  }, [counts, getAnalyticsData, limits]);

  return (
    <Scopes names={CONTENT_LIMIT_MODAL}>
      <Modal
        isOpen={showModal}
        onCloseClick={onClose}
        onBackgroundClick={onClose}
        maxWidth={55}
      >
        <img className="logo accenture" src={contentLimitIcon} />
        <Spacer bottom={3} />
        <Text fontWeight="medium" alignment="center" size="large">
          You’re over your limit of {limits?.TOTAL_ASSETS} free videos and
          screenshots.
        </Text>
        <Spacer bottom={2} />
        <Text size="medium" alignment="center" color="bodyDimmed">
          This {contentType} is on us, but we’ll enforce the limit soon.
          Upgrading also unlocks unlimited recording time and a toolkit of new
          features to help get your message across.
        </Text>
        <Spacer bottom={2} />
        <Button
          variant="upgrade"
          size="large"
          icon={<SvgSparkle />}
          onClick={() => {
            track(CONTENT_LIMIT_MODAL_CLICKED, getAnalyticsData(counts), () => {
              window.location.href = PLANS_AND_BILLING;
            });
          }}
        >
          Upgrade
        </Button>
      </Modal>
    </Scopes>
  );
};

export default ContentLimitPaywallModal;
